import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/api/queryKeys'
import * as notesApi from '@/api/notes'
import type { Note } from '@/types'

export function useNotesByPriority(priorityId: string | null | undefined): Note[] | undefined {
  const { data } = useQuery({
    queryKey: queryKeys.notes.byPriority(priorityId),
    queryFn: () => notesApi.fetchNotesByPriority(priorityId!),
    enabled: !!priorityId,
  })
  return priorityId ? data : []
}

export function useNotesByBucket(bucketId: string | null | undefined): Note[] | undefined {
  const { data } = useQuery({
    queryKey: queryKeys.notes.byBucket(bucketId),
    queryFn: () => notesApi.fetchNotesByBucket(bucketId!),
    enabled: !!bucketId,
  })
  return bucketId ? data : []
}

export function useAddNote() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ body, entity }: { body: string; entity: { priorityId: string } | { bucketId: string } }) =>
      notesApi.addNote(body, entity),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['notes'] }),
  })
}

export function useDeleteNote() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: notesApi.deleteNote,
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['notes'] }),
  })
}
